export const LS_IS_JUST_SIGNED_IN_NAME = 'justSignedIn';
export const LS_IS_JUST_SIGNED_IN_VALUE = '1';
export const LS_DUBBING_WARNING_MODAL_DISABLED = 'dubbingWarningModalDisabled';
export const LS_SPLIT_SEGMENT_MODAL_DISABLED = 'splitSegmentModalDisabled';
